import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import Box from 'components/Box';
import Stack from 'components/Stack';
import Text from 'components/Text';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ShareWithEveryoneWidget() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: "xs",
    children: [/*#__PURE__*/_jsx(Box, {
      grow: true,
      shrink: true,
      children: /*#__PURE__*/_jsx(Text, {
        bold: true,
        as: "h3",
        overflow: "wrap",
        children: t('advanced_audience_widget_audience_colon')
      })
    }), /*#__PURE__*/_jsx(Box, {
      background: "shaded",
      borderRadius: "small",
      px: "s",
      py: "xs",
      children: /*#__PURE__*/_jsx(Heading, {
        as: "p",
        size: "small",
        children: t('state_everyone_with_access')
      })
    })]
  });
}
export default ShareWithEveryoneWidget;